import React from 'react';
import { Zap, ShieldCheck, CalendarCheck, Lock, Headphones, MapPin } from 'lucide-react';
import { mockData } from '../mock';

const iconMap = {
  'zap': Zap,
  'shield-check': ShieldCheck,
  'calendar-check': CalendarCheck,
  'lock': Lock,
  'headphones': Headphones,
  'map-pin': MapPin
};

const ServicesSection = () => {
  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">
            Why Choose <span className="text-yellow-400">bHyyve</span>?
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Experience the future of service booking with our innovative platform
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {mockData.services.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group bg-white p-8 rounded-2xl border-2 border-gray-200 hover:border-yellow-400 transition-all duration-300 hover:shadow-xl"
              >
                <div className="bg-yellow-400 w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="text-black" size={32} />
                </div>
                <h3 className="text-xl font-bold text-black mb-3">{service.title}</h3>
                <p className="text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;